if ( typeof ColourSwatches !== 'function' ) {

	class ColourSwatches extends HTMLElement {

		constructor() {

			super();

			this.viewport = this.querySelector('.colour-swatches__viewport');
			this.track = this.querySelector('.colour-swatches__track');
			this.revealNextButton = this.querySelector('.colour-swatches__reveal-next');
			this.revealPrevButton = this.querySelector('.colour-swatches__reveal-prev');

			if ( ! this.viewport || ! this.track ) return;

			// Small inline arrow sitting right next to the swatch dots.
			this.revealNextButton?.addEventListener('click', ()=>{
				this.stepToNeighbour(1);
			});
			this.revealPrevButton?.addEventListener('click', ()=>{
				this.stepToNeighbour(-1);
			});
			this.track.addEventListener('click', (event)=>{
				if ( event.target.closest('.coloursquare') ) {
					this.updateArrowVisibility();
					this.centerActive(true);
				}
			});
			this.viewport.addEventListener('scroll', debounce(()=>{
				this.updateArrowVisibility();
			}, 100), { passive: true });

			this.updateArrowVisibility();

		}

		stepToNeighbour(direction){
			const active = this.track.querySelector('.coloursquare--active');
			if ( ! active ) return;
			// The reveal-prev/-next buttons already swap physical sides in RTL
			// via flex-direction:row mirroring, so which sibling each one
			// targets stays the same regardless of direction.
			const target = direction > 0 ? active.nextElementSibling : active.previousElementSibling;
			if ( ! target || ! target.classList.contains('coloursquare') ) return;
			target.click();
		}

		centerActive(animate){
			const active = this.track.querySelector('.coloursquare--active');
			if ( ! active ) return;
			const target = active.offsetLeft + ( active.offsetWidth / 2 ) - ( this.viewport.clientWidth / 2 );
			if ( animate ) {
				this.animateScrollBy( target - this.viewport.scrollLeft, 400 );
			} else {
				const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
				this.viewport.scrollLeft = Math.max(0, Math.min(maxScroll, target));
				this.updateArrowVisibility();
			}
		}

		animateScrollBy(distance, duration){
			const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
			const rtl = document.documentElement.getAttribute('dir') == 'rtl';
			// In an RTL-direction scroll container, browsers report scrollLeft as
			// 0 (start) down to -maxScroll (end) instead of 0 up to maxScroll.
			const lowerBound = rtl ? -maxScroll : 0;
			const upperBound = rtl ? 0 : maxScroll;
			const start = this.viewport.scrollLeft;
			const target = Math.max(lowerBound, Math.min(upperBound, start + distance));
			const change = target - start;
			const startTime = performance.now();
			const easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
			const step = (now) => {
				const progress = Math.min(1, (now - startTime) / duration);
				this.viewport.scrollLeft = start + change * easeInOutQuad(progress);
				this.updateArrowVisibility();
				if ( progress < 1 ) requestAnimationFrame(step);
			};
			requestAnimationFrame(step);
		}

		updateArrowVisibility(){
			const active = this.track.querySelector('.coloursquare--active');
			const prevSwatch = active ? active.previousElementSibling : null;
			const nextSwatch = active ? active.nextElementSibling : null;
			// The active swatch always renders first in the track, so on a
			// fresh page load revealPrevButton would otherwise sit there
			// doing nothing (no previous swatch to step to) until the
			// customer has clicked next at least once.
			if ( this.revealPrevButton ) this.revealPrevButton.classList.toggle('hide', ! prevSwatch);
			if ( this.revealNextButton ) this.revealNextButton.classList.toggle('hide', ! nextSwatch);
		}

	}

	if ( typeof customElements.get('colour-swatches') == 'undefined' ) {
		customElements.define('colour-swatches', ColourSwatches);
	}

}
